module.exports = __webpack_public_path__ + "media/customizations/trilogy/logo-46e736c81cc4cf2aa168158caeb45bb5.png";